import React from 'react';
import moment from 'moment';

export class TimePicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selHour: undefined,
      selMinute: undefined,
    }
  }

  selHour(h) {
    this.setState({selHour: h}, () => this.commitWhenPossible());
  }

  selMinute(m) {
    this.setState({selMinute: m}, () => this.commitWhenPossible());
  }

  commitWhenPossible() {
    let multipleMinuteChoices = 60 / this.props.minuteStep > 1;
    if(
      (multipleMinuteChoices && this.state.selHour !== undefined && this.state.selMinute !== undefined) ||
      (!multipleMinuteChoices && this.state.selHour !== undefined)
    ) {
      const mValue = moment(this.props.value);
      mValue.hours(this.state.selHour);
      mValue.minutes(this.state.selMinute);
      this.props.onChange && this.props.onChange(mValue);
    }
  }

  render() {
    const {hourStep, minuteStep, hourBase, minuteBase, value} = this.props;
    /*const mValue = moment(value);
    const hour = mValue.hours();
    const minute = mValue.minutes();*/

    const hour = this.state.selHour;
    const minute = this.state.selMinute;

    let hours = [];
    let minutes = [];
    for(let i = hourBase; i < 24; i += hourStep) {
      hours.push(i);
    }
    for(let i = minuteBase; i < 60; i += minuteStep) {
      minutes.push(i);
    }

    return (
      <div className={"time-picker" + (this.props.hidden ? " hidden" : "")}>
        <div className="hours">
          {hours.map(h =>
            <div onClick={() => this.selHour(h)} className={"hour" + (h === hour ? " selected": "")} key={h}>
              {h}
            </div>
          )}
        </div>
        {minutes.length > 1 && <div className="minutes">
          {minutes.map(m => 
            <div onClick={() => this.selMinute(m)} className={"minute" + (m === minute ? " selected": "")} key={m}>
              {m}
            </div>          
          )}
        </div>}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/TimePicker.js